import * as React from "react";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import PersonAdd from "@mui/icons-material/PersonAdd";
import Settings from "@mui/icons-material/Settings";
import Logout from "@mui/icons-material/Logout";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useNavigate } from "react-router-dom";
import LoginIcon from "@mui/icons-material/Login";
import LockResetIcon from "@mui/icons-material/LockReset";
import api from "../config/axios";

export default function AccountDropDownMenu() {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [profile, setProfile] = React.useState(null);
  const open = Boolean(anchorEl);

  // Check if user is logged in
  const isLoggedIn = localStorage.getItem("token") !== null;

  React.useEffect(() => {
    if (isLoggedIn) {
      // Fetch current user data
      api
        .get("/auth/me")
        .then((res) => {
          setProfile(res.data);
        })
        .catch((err) => {
          console.error("Error fetching user data:", err);
        });
    }
  }, [isLoggedIn]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setProfile(null);
    navigate("/login");
    handleClose();
  };

  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center", textAlign: "center" }}>
        <Tooltip title="Account settings">
          <IconButton
            onClick={handleClick}
            size="small"
            aria-controls={open ? "account-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
          >
            <Avatar
              component="button"
              src={profile?.profileImage || "/images/navbar-profile-pic.jpeg"}
              alt="Profile Picture"
              sx={{
                width: 42,
                height: 42,
                objectFit: "cover",
                cursor: "pointer",
                p: "0px",
                border: "transparent",
              }}
            />
          </IconButton>
        </Tooltip>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              "&::before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        {isLoggedIn ? (
          // Menu items for logged in users
          <>
            <MenuItem onClick={() => navigate("/profile")}>
              <Avatar
                src={profile?.profileImage || "/images/navbar-profile-pic.jpeg"}
                alt="Profile Picture"
              />
              Profile
            </MenuItem>
            <MenuItem onClick={() => navigate("/job-board-homepage")}>
              Job Board Homepage
            </MenuItem>
            <MenuItem onClick={() => navigate("/companies")}>
              Companies
            </MenuItem>
            <MenuItem onClick={() => navigate("/settings")}>
              <ListItemIcon>
                <Settings fontSize="small" />
              </ListItemIcon>
              Settings
            </MenuItem>
            <Divider />
            <MenuItem onClick={handleLogout}>
              <ListItemIcon>
                <Logout fontSize="small" />
              </ListItemIcon>
              Logout
            </MenuItem>
          </>
        ) : (
          // Menu items for non-logged in users
          <>
            <MenuItem onClick={() => navigate("/login")}>
              <ListItemIcon>
                <LoginIcon sx={{ width: 20, height: 20 }} />
              </ListItemIcon>
              Login
            </MenuItem>
            <MenuItem onClick={() => navigate("/sign-up")}>
              <ListItemIcon>
                <PersonAdd fontSize="small" />
              </ListItemIcon>
              Sign Up
            </MenuItem>
            <MenuItem onClick={() => navigate("/forgot-password")}>
              <ListItemIcon>
                <LockResetIcon sx={{ width: 20, height: 20 }} />
              </ListItemIcon>
              Forgot Password
            </MenuItem>
            <MenuItem onClick={() => navigate("/job-board-homepage")}>
              Job Board Homepage
            </MenuItem>
            <MenuItem onClick={() => navigate("/companies")}>
              Companies
            </MenuItem>
          </>
        )}
      </Menu>
    </>
  );
}
